/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from 'angular2-grid/components/NgGridPlaceholder';
const styles_NgGridPlaceholder:any[] = ([] as any[]);
export const RenderType_NgGridPlaceholder:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_NgGridPlaceholder,data:{}});
export function View_NgGridPlaceholder_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,([] as any[]),(null as any),(null as any));
}
export function View_NgGridPlaceholder_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'ng-grid-placeholder',
      ([] as any[]),(null as any),(null as any),(null as any),View_NgGridPlaceholder_0,
      RenderType_NgGridPlaceholder)),i0.ɵdid(1,114688,(null as any),0,i1.NgGridPlaceholder,
      [i0.ElementRef,i0.Renderer],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const NgGridPlaceholderNgFactory:i0.ComponentFactory<i1.NgGridPlaceholder> = i0.ɵccf('ng-grid-placeholder',
    i1.NgGridPlaceholder,View_NgGridPlaceholder_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvZ2l0bGFiLXJ1bm5lci9idWlsZHMvVnlRUUFUTnUvMC9ncm91cGUtZGV2L25tMTcvbm9kZV9tb2R1bGVzL2FuZ3VsYXIyLWdyaWQvY29tcG9uZW50cy9OZ0dyaWRQbGFjZWhvbGRlci5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL2dpdGxhYi1ydW5uZXIvYnVpbGRzL1Z5UVFBVE51LzAvZ3JvdXBlLWRldi9ubTE3L25vZGVfbW9kdWxlcy9hbmd1bGFyMi1ncmlkL2NvbXBvbmVudHMvTmdHcmlkUGxhY2Vob2xkZXIuZC50cyIsIm5nOi8vL2hvbWUvZ2l0bGFiLXJ1bm5lci9idWlsZHMvVnlRUUFUTnUvMC9ncm91cGUtZGV2L25tMTcvbm9kZV9tb2R1bGVzL2FuZ3VsYXIyLWdyaWQvY29tcG9uZW50cy9OZ0dyaWRQbGFjZWhvbGRlci5kLnRzLk5nR3JpZFBsYWNlaG9sZGVyX0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPG5nLWdyaWQtcGxhY2Vob2xkZXI+PC9uZy1ncmlkLXBsYWNlaG9sZGVyPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7a0NBQUEsVUFBQTtNQUFBO0lBQUE7Ozs7In0=



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/src/$$_gendir/node_modules/angular2-grid/components/NgGridPlaceholder.ngfactory.ts